import React, { useRef, useCallback } from "react";
import { Form, Row, Col, Input, Select, DatePicker, Button, Space } from "antd";
import { SearchOutlined, ReloadOutlined } from "@ant-design/icons";

const { RangePicker } = DatePicker;

/**
 * 账单列表筛选组件
 *
 * @param {boolean} autoApply - 自动应用模式：表单值变化自动触发 onSearch（防抖 500ms），隐藏搜索/重置按钮
 */
const InvoiceListFilter = ({ onSearch, onReset, autoApply = false }) => {
    const [form] = Form.useForm();
    const debounceRef = useRef(null);

    const handleSearch = useCallback(() => {
        form.validateFields().then((values) => {
            onSearch(values);
        });
    }, [form, onSearch]);

    const handleReset = useCallback(() => {
        form.resetFields();
        onReset();
    }, [form, onReset]);

    // autoApply 模式：表单值变化自动触发搜索（防抖）
    const handleValuesChange = useCallback(() => {
        if (!autoApply) return;
        if (debounceRef.current) clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => {
            handleSearch();
        }, 500);
    }, [autoApply, handleSearch]);

    return (
        <Form form={form} layout="vertical" className="search-form" onValuesChange={handleValuesChange}>
            <Row gutter={24}>
                <Col span={6}>
                    <Form.Item name="invoice_number" label="账单号">
                        <Input placeholder="请输入账单号" allowClear onPressEnter={handleSearch} />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item name="supplier_name" label="供应商">
                        <Input placeholder="请输入供应商名称" allowClear onPressEnter={handleSearch} />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item name="status" label="状态">
                        <Select placeholder="请选择状态" allowClear mode="multiple">
                            <Select.Option value="DRAFT">草稿 (DRAFT)</Select.Option>
                            <Select.Option value="PENDING_MATCHING">待匹配 (PENDING_MATCHING)</Select.Option>
                            <Select.Option value="PARTIALLY_RECONCILED">部分对账 (PARTIALLY_RECONCILED)</Select.Option>
                            <Select.Option value="RECONCILED">已对账 (RECONCILED)</Select.Option>
                            <Select.Option value="DISPUTED">有争议 (DISPUTED)</Select.Option>
                            <Select.Option value="PAID">已支付 (PAID)</Select.Option>
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item name="lifecycle_status" label="生命周期">
                        <Select placeholder="请选择生命周期" allowClear mode="multiple">
                            <Select.Option value="ACTIVE">有效</Select.Option>
                            <Select.Option value="VOID">已作废</Select.Option>
                            <Select.Option value="REPLACED">已替代</Select.Option>
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item name="date_range" label="账单日期">
                        <RangePicker style={{ width: "100%" }} />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item name="has_allocation" label="是否分摊">
                        <Select placeholder="请选择" allowClear>
                            <Select.Option value={true}>是</Select.Option>
                            <Select.Option value={false}>否</Select.Option>
                        </Select>
                    </Form.Item>
                </Col>
            </Row>
            {!autoApply && (
                <Row>
                    <Col span={24} style={{ textAlign: "right" }}>
                        <Space>
                            <Button icon={<ReloadOutlined />} onClick={handleReset}>
                                重置
                            </Button>
                            <Button type="primary" icon={<SearchOutlined />} onClick={handleSearch}>
                                查询
                            </Button>
                        </Space>
                    </Col>
                </Row>
            )}
        </Form>
    );
};

export default InvoiceListFilter;
